import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import { LocationStrategy } from '@angular/common';


@Component({
  selector: 'app-standard-type-acronyms',
  templateUrl: './standard-type-acronyms.component.html'
})
export class StandardTypeAcronymsComponent implements OnInit {

  constructor(private location: LocationStrategy, private sanitizer: DomSanitizer,public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService, private openlink: OpenLinkById) {
  }

  st_header;
  st_description;
  st_acronymheader;
   st_acronym;
  st_acronymdescription;
  st_acronymsdisplay: { key: string, value: string }[] = [];
  st_acronymsheaderdisplay=[];


  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
   
    this.getstandardtypeacronymscomponentlabels();
  }
  getstandardtypeacronymscomponentlabels() {

    this.graphQlService.getStandardTypeAcronymslabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.st_header = labels.filter(x => x.key == "st_header").map(y => y.value);
        this.st_description = labels.filter(x => x.key == "st_description").map(y => y.value);
        
        this.st_acronymsheaderdisplay = labels.filter(x => x.key == "st_acronymsheader").map(y => y.value)[0].split(":");

        this.st_acronym = labels.filter(x => x.key == "st_acronym").map(y => y.value);
        
        let acronym_arr = this.st_acronym[0].split(",").map(d => d.split(":"));
        acronym_arr.forEach(d=>{

          this.st_acronymsdisplay.push({ key: d[0], value: d[1] });

        });
        this.st_acronymdescription = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "st_acronymdescription").map(y => y.value));

        this.commonDataService.showLoader.next(false);
      }
      
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openLinkById(event) {
    this.openlink.openLinkById(event);
  }

}
